import { render, staticRenderFns } from "./p1s1c2c3CustomersList.vue?vue&type=template&id=6e2df8d4&scoped=true"
import script from "./p1s1c2c3CustomersList.vue?vue&type=script&lang=js"
export * from "./p1s1c2c3CustomersList.vue?vue&type=script&lang=js"
import style0 from "./p1s1c2c3CustomersList.vue?vue&type=style&index=0&id=6e2df8d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2df8d4",
  null
  
)

export default component.exports